var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-outline 1",
    clipPath: "url(#clip0_441_10557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4358 20.8975L18.7525 17.225C19.9409 15.711 20.5857 13.8414 20.5833 11.9167C20.5833 10.2026 20.075 8.52695 19.1227 7.10173C18.1704 5.6765 16.8169 4.56567 15.2333 3.90971C13.6496 3.25376 11.9071 3.08213 10.2259 3.41653C8.54472 3.75094 7.00047 4.57636 5.78841 5.78841C4.57636 7.00047 3.75094 8.54472 3.41653 10.2259C3.08213 11.9071 3.25376 13.6496 3.90971 15.2333C4.56567 16.8169 5.6765 18.1704 7.10173 19.1227C8.52695 20.075 10.2026 20.5833 11.9167 20.5833C13.8414 20.5857 15.711 19.9409 17.225 18.7525L20.8975 22.4358C20.9982 22.5374 21.118 22.618 21.25 22.673C21.3821 22.728 21.5237 22.7563 21.6667 22.7563C21.8097 22.7563 21.9513 22.728 22.0833 22.673C22.2153 22.618 22.3351 22.5374 22.4358 22.4358C22.5374 22.3351 22.618 22.2153 22.673 22.0833C22.728 21.9513 22.7563 21.8097 22.7563 21.6667C22.7563 21.5237 22.728 21.3821 22.673 21.25C22.618 21.118 22.5374 20.9982 22.4358 20.8975ZM5.41667 11.9167C5.41667 10.6311 5.79789 9.37438 6.51212 8.30546C7.22635 7.23655 8.24151 6.40342 9.42923 5.91145C10.6169 5.41948 11.9239 5.29076 13.1848 5.54157C14.4456 5.79237 15.6038 6.41144 16.5129 7.32048C17.4219 8.22952 18.041 9.38771 18.2918 10.6486C18.5426 11.9095 18.4139 13.2164 17.9219 14.4041C17.4299 15.5918 16.5968 16.607 15.5279 17.3212C14.459 18.0355 13.2022 18.4167 11.9167 18.4167C10.1928 18.4167 8.53946 17.7319 7.32048 16.5129C6.10149 15.2939 5.41667 13.6406 5.41667 11.9167Z",
    fill: "#232738"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_10557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutline);
export default __webpack_public_path__ + "static/media/search-outline.c80328eb38a5a05d61984a4b2acb6aab.svg";
export { ForwardRef as ReactComponent };